import AddButton from "../../../../components/AddButton";
import { useState, useEffect, useRef } from "react";
import {
  FunnelIcon,
  NewspaperIcon,
  ArrowRightIcon,
  ArrowUpCircleIcon,
} from "@heroicons/react/24/solid";
import TableFilters from "./TableFilters";
import { MassUpload } from "../massupload/MassUpload";
import MassUploadButton from "../../../../components/MassUploadButton";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilState, useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { CSVLink } from "react-csv";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "../../../../components/toastNotification";
import {
  agmtAddState,
  agmtEditState,
  isOpenFilter,
  agmtFilterParams,
  agmtFilterValues,
  agmtTableData,
  searchedAgmtTableData,
  isFilteredState,
  agmtEditMassUpload,
  agmtGroupedData,
  agmtShowGroupState,
  agmtFullView,
  agmtGrpFilterParams,
  agmtEditMainState,
  filterConflictingAgreement,
  conflictingAgreementId,
  filteredAgreementData,
  agreementFormData,
  pendingEditRow,
} from "../atoms/atoms";
import useAgreementsRepo from "../hooks/useAgreementsRepo";
import useAgreementForDownload from "../hooks/useAgreementForDownload";
import useSearchAgreements from "../hooks/useSearchAgreements";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import { AgmtGroupView } from "./AgmtGroupView";
import { AgmtFullViewModal } from "./AgmtFullViewModal";
import DownloadButton from "../../../../components/DownloadButton";
import AgreementForm from "../forms/AgreementForm";

const AgreementsTable = () => {
  let location = useLocation();
  const history = useHistory();
  const user = useRecoilValue(accountAtom);
  const addPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_agreement_add;

  const userPermissions = useRecoilValue(permissionsSelector);
  let dateTimeToday = new Date(new Date().toISOString()).toISOString();

  const [agreementsData, setAgreementsData] = useRecoilState(agmtTableData);
  const [agmtGroupData, setAgmtGroupData] = useRecoilState(agmtGroupedData);
  const [filterGrpParams, setFilterGrpParams] =
    useRecoilState(agmtGrpFilterParams);
  const [showGroupView, setShowGroupView] = useRecoilState(agmtShowGroupState);
  const [, setEditMainState] = useRecoilState(agmtEditMainState);
  const [showFullView] = useRecoilState(agmtFullView);
  const [searchedAgreementsData, setsearchedAgreementsData] = useRecoilState(
    searchedAgmtTableData
  );
  const [filter, setFilter] = useRecoilState(isOpenFilter);
  const [, setFilteredAgmtData] = useRecoilState(filteredAgreementData);

  const [filterParams, setFilterParams] = useRecoilState(agmtFilterParams);
  const [conflictFilterParams, setConflictFilterParams] =
    useState(agmtFilterParams);
  const [filteredValue, setFiltervalues] = useRecoilState(agmtFilterValues);
  const [isFiltered, setIsFiltered] = useRecoilState(isFilteredState);
  const [massUploadModal, setMassUploadModal] = useState(false);
  const [isFranchiseUpload, setIsFranchiseUpload] = useState(false);
  const [addState, setAddState] = useRecoilState(agmtAddState);
  const [, setEditState] = useRecoilState(agmtEditState);
  const [, setEditMassUpload] = useRecoilState(agmtEditMassUpload);
  const [filterConflictingAgreements, setFilterConflictingAgreements] =
    useRecoilState(filterConflictingAgreement);
  const [conflictingAgreementIds, setConflictingAgreementIds] = useRecoilState(
    conflictingAgreementId
  );
  const [savedAgreementData] = useRecoilState(agreementFormData);
  const [, setPendingEditRow] = useRecoilState(pendingEditRow);
  const { mutateAsync: getAgmtForDownload, isLoading: getAgmtDetailsLoading } =
    useAgreementForDownload();
  const [exportdata, setExportdata] = useState([]);
  const downloadRef = useRef();
  const agmtTableRef = useRef();

  useEffect(() => {
    setAddState(false);
    setEditState(false);
    setEditMassUpload(false);
    setFilterParams();
    setFilter(false);
    setIsFiltered(false);
    setShowGroupView(false);
    setEditMainState(false);
    setFilterConflictingAgreements(false);
  }, []);

  //UseHooks for main agreement table data
  const {
    status: getAgmtStatus,
    data: agmtData,
    isFetching: agmtLoading,
    refetch: agmtRefetch,
  } = useAgreementsRepo();

  const {
    mutateAsync: searchAgreements,
    status: searchAgmtStatus,
    data: searchAgmtData,
    isLoading: searchAgmtLoading,
    reset: resetSearchAgreement,
  } = useSearchAgreements();

  const mutateSearchAgreements = async (fromSearch) => {
    await searchAgreements(fromSearch ? filterParams : conflictFilterParams);
  };

  useEffect(() => {
    // Handle getAgmtStatus success
    if (getAgmtStatus === "success" && agmtData) {
      if (agmtData.statusCode) {
        toast.fire("Server Error", "Cannot Get Agreement Data", "error");
        setAgreementsData([]);
      } else {
        setAgreementsData(agmtData.map((data) => ({ ...data }))); // fix for non-extensible object
      }
    }
    // Handle searchAgmtStatus success
    if (
      searchAgmtStatus === "success" &&
      searchAgmtData?.data &&
      (filterParams || conflictFilterParams)
    ) {
      setIsFiltered(true);
      if (searchAgmtData.status !== 200) {
        toast.fire("Server Error", "Cannot Get Agreement Data", "error");
        setsearchedAgreementsData([]);
      } else {
        setsearchedAgreementsData(
          searchAgmtData.data.map((data) => ({ ...data }))
        );
      }

      history.replace();
    }
  }, [
    getAgmtStatus,
    agmtData,
    searchAgmtStatus,
    searchAgmtData,
    filterParams,
    history,
  ]);

  const reset = () => {
    setsearchedAgreementsData();
    setFilterParams();
    setConflictFilterParams();
    setFiltervalues({
      AgencyList: [],
      Carrier: [],
      Commission: null,
      EntityList: [],
      EffectiveDateTo: null,
      EffectiveDateFrom: null,
      ExpirationDate: null,
      AgreementIsActive: null,
      IsFranchise: null,
      PolicyType: null,
      SalesLead: null,
      State: [],
      Billing: null,
      masterLegalEntityId: null,
      isWritingNewBusiness: null,
    });
    setFilteredAgmtData([]);
    setIsFiltered(false);
    setFilterConflictingAgreements(false);
    setConflictingAgreementIds([]);
    resetSearchAgreement();
  };

  // Get All Details for Download function
  const downloadAgreements = () => {
    const agmtIds = isFiltered
      ? searchedAgreementsData.map((x) => x.agreementRepositoryId)
      : agreementsData?.map((x) => x.agreementRepositoryId);
    let dateToday = new Date().toJSON();
    getAgmtForDownload(agmtIds.join(",").split(","), {
      onSuccess: (res) => {
        if (res) {
          setExportdata(
            res.map((x) => {
              return {
                agreementRepositoryId: x.agreementRepositoryId,
                carrier: x.carrier,
                masterCarrierId: x.masterCarrierId,
                program: x.program,
                standard: x.standard,
                agency: x.agency,
                entityId: x.entityId,
                state: x.state,
                paidType: x.paidType,
                policyType: x.policyType,
                policyPrefix: x.policyPrefix,
                newPercentage: x.newPercentage,
                newPercentageConfie: x.newPercentageConfie,
                newPercentageFranchise: x.newPercentageFranchise,
                renewalPercentage: x.renewalPercentage,
                renewPercentageConfie: x.renewPercentageConfie,
                renewPercentageFranchise: x.renewPercentageFranchise,
                flatRatePerPolicy: x.flatRatePerPolicy,
                newBusinessFlatRate: x.newBusinessFlatRate,
                renewalFlatRate: x.renewalFlatRate,
                AgreementStatus: x.agreementIsActive
                  ? x.expirationDate < dateToday
                    ? "Expired"
                    : "Active"
                  : x.expirationDate < dateToday
                  ? "Expired"
                  : "Inactive",
                usedInCommVal: x.isActive === true ? "True" : "False",
                isFranchise: x.isFranchise,
                effectiveDate: x.effectiveDate,
                expirationDate: x.expirationDate,
                notes: x.notes,
                licensedTypeId: x.licensedTypeId,
                producerCode: x.producerCode,
                agreementType: x.agreementType,
                appointedBy: x.planCode,
                term: x.term,
                createdOn: x.createdOn,
                createdBy: x.createdBy,
                modifiedOn: x.updatedOn,
                modifiedBy: x.updatedBy,
                otherInsurance: x.otherInsurance,
                pifMax: x.pifMax,
                pifMin: x.pifMin,
                otherCommissionPercentage: x.otherCommissionPercentage,
                otherCommissionTransaction: x.otherCommissionTransaction,
                billing: x.billing,
                paymentRemittanceType: x.paymentRemittanceType,
                commissionPaymentsFrequency: x.commissionPaymentsFrequency,
                contingentCommission: x.contingentCommission,
                sourceFiles: x?.sourceLink,
                salesLeadId: x.salesLead,
                salesLeadName: x.salesLeadName,
                entityName: x.entityName,
                entityEIN: x.entityEIN,
                masterLegalEntity: x.masterEntityName,
                licenseNumber: x.licenseNumber,
                licenseTypeName: x.licenseTypeName,
                lineOfBusinessId: x.lineOfBusinessId,
                businessTypeId: x.businessTypeId,
                lineOfBusinessName: x.lineOfBusinessName,
                businessTypeName: x.businessTypeName,
                commissionUpdatedBy: x.commissionUpdatedBy,
                commissionUpdatedOn: x.commissionUpdatedOn,
                isWritingNewBusiness: x.isWritingNewBusiness,
                isOverridePayment: x?.isOverridePayment,
                overridePaymentType: x?.overridePaymentType,
                overridePercentage: x?.overridePercentage,
                overrideRenewalPercentage: x?.overrideRenewalPercentage,
              };
            })
          );
          downloadRef.current.link.click();
          toast.fire(
            "Download Agreement ",
            "Successfully Downloaded Agreement",
            "success"
          );
        }
      },
      onError: (error) => {
        if (error) {
          toast.fire(
            "Download Agreement ",
            "Server Error: Cannot Download Agreement",
            "error"
          );
        }
      },
    });
  };

  let recordIdFromRecent = "";
  if (location.state !== null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent && recordIdFromRecent.moduleName === "Agreement") {
      setIsFiltered(true);
      setFilter(true);
      if (recordIdFromRecent.action === "viewSettings") {
        setFilterParams({ CarrierId: [recordIdFromRecent.recordId] });
      } else {
        setFilterParams({
          AgreementRepositoryId: recordIdFromRecent.recordId.split("."),
        });
      }
    }
    if (filterConflictingAgreements) {
      setIsFiltered(true);
      setFilter(true);
      setConflictFilterParams({
        AgreementRepositoryId: conflictingAgreementIds,
      });
    }
  }, [
    recordIdFromRecent,
    filterConflictingAgreements,
    conflictingAgreementIds,
    setFilter,
    setFilterConflictingAgreements,
    setFilterParams,
    setIsFiltered,
  ]);

  useEffect(() => {
    if (
      filterParams &&
      (filterParams.AgreementRepositoryId?.length > 0 ||
        filterParams.CarrierId?.length > 0) &&
      recordIdFromRecent
    ) {
      mutateSearchAgreements(true);
    }
    if (
      conflictFilterParams &&
      conflictFilterParams.AgreementRepositoryId?.length > 0 &&
      filterConflictingAgreements
    ) {
      mutateSearchAgreements(false);
    }
  }, [
    filterParams,
    conflictFilterParams,
    filterConflictingAgreements,
    recordIdFromRecent,
  ]);

  const csvReport = {
    filename: "AgreementReport_" + dateTimeToday + ".csv",
    data: exportdata,
  };

  const onClickCarrier = (groupedData) => {
    setAgmtGroupData(groupedData);
    setFilterGrpParams({
      ...filterGrpParams,
      AgreementRepositoryId: groupedData.agreementRepositoryId
        .split(",")
        .map((x) => parseInt(x)),
    });
    setShowGroupView(true);
  };
  const mainColumns = [
    {
      title: "Carrier",
      field: "carrier",
      render: (rowData, rowStatus) => {
        if (rowStatus === "group") {
          return rowData;
        } else {
          return (
            <div className="flex flex-col cursor-pointer justify-end w-full text-sm">
              <div
                className="blueAndBold underline uppercase"
                onClick={() => onClickCarrier(rowData)}
              >
                {rowData.carrier ? rowData.carrier : "unspecified"}
              </div>
              <div className="mainLabeltextColor">Carrier</div>
            </div>
          );
        }
      },
    },
    {
      title: "Agency",
      hidden:
        ((filteredValue.AgencyList?.length === 0 ||
          !filteredValue.AgencyList) &&
          isFiltered) ||
        !isFiltered,
      field: "agency",
      render: (rowData, rowStatus) => {
        if (rowStatus === "group") {
          return rowData;
        } else {
          return (
            <div className="flex flex-col text-sm">
              <div className="font-medium text-blue-500">
                {rowData.agency ? rowData.agency : "unspecified"}
              </div>
              <div className="mainLabeltextColor">Agency</div>
            </div>
          );
        }
      },
    },
    {
      title: "Legal Entity",
      field: "entityName",

      render: (rowData, rowStatus) => {
        if (rowStatus === "group") {
          return rowData;
        } else {
          return (
            <div className="flex flex-col text-sm">
              <div className="blueAndBold uppercase">
                {rowData.entityName ? rowData.entityName : "unspecified"}
              </div>
              <div className="mainLabeltextColor">Legal Entity</div>
            </div>
          );
        }
      },
    },
    {
      title: "Master Legal Entity",
      field: "masterLegalEntityId",

      render: (rowData, rowStatus) => {
        if (rowStatus === "group") {
          return rowData;
        } else {
          return (
            <div className="flex flex-col text-sm">
              <div className="blueAndBold uppercase">
                {rowData.masterEntityName
                  ? rowData.masterEntityName
                  : "unspecified"}
              </div>
              <div className="mainLabeltextColor">Master Legal Entity</div>
            </div>
          );
        }
      },
    },
    {
      hidden: (filteredValue.Commission === null && isFiltered) || !isFiltered,
      field: "paidType",
      render: (rowData) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div>{rowData.paidType}</div>
            <div className="mainLabeltextColor">Paid Type</div>
          </div>
        );
      },
    },
    {
      field: "policyType",
      render: (rowData) => {
        return (
          <div className="blueAndBold uppercase whitespace-normal">
            <div>{rowData.policyType ? rowData.policyType : "unspecified"}</div>
            <div className="mainLabeltextColor">Policy Type</div>
          </div>
        );
      },
    },
    {
      field: "state",
      render: (rowData) => {
        return (
          <div className="blueAndBold uppercase whitespace-normal">
            <div>{rowData.state ? rowData.state : "unspecified"}</div>
            <div className="mainLabeltextColor">State</div>
          </div>
        );
      },
    },
    {
      field: "Sales Lead",
      hidden: (filteredValue.SalesLead === null && isFiltered) || !isFiltered,
      render: (rowData, rowStatus) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div>
              {rowData.salesLeadName ? rowData.salesLeadName : "undefined"}
            </div>
            <div className="mainLabeltextColor">Sales Lead</div>
          </div>
        );
      },
    },
    {
      width: "20px",
      field: "newPercentage",
      render: (rowData) => {
        return (
          <>
            {rowData.flatRatePerPolicy ? (
              <div className="flex flex-col items-center font-bold text-xxs">
                <span
                  className={`inline-flex items-center w-5 justify-center w-10 px-1 py-0.5 rounded-full 
              text-xs font-medium bg-blue-500 text-white`}
                >
                  $
                  {rowData.newBusinessFlatRate
                    ? rowData.newBusinessFlatRate
                    : 0}
                </span>
                <div className={`agmtColumn text-blue-500`}>New Flat Rate</div>
              </div>
            ) : (
              <div className="flex flex-col items-center font-bold text-xxs">
                <span
                  className={`inline-flex items-center w-5 justify-center w-10 px-1 py-0.5 rounded-full 
              text-xs font-medium bg-blue-500 text-white`}
                >
                  {rowData.newPercentage}
                </span>
                <div className={`agmtColumn text-blue-500`}>New %</div>
              </div>
            )}
          </>
        );
      },
    },
    {
      width: "20px",
      field: "newPercentageConfie",
      hidden:
        !user.isFranchise ||
        (filteredValue.IsFiltered && filterParams.IsFranchise === false),
      render: (rowData) => {
        return (
          rowData.isFranchise &&
          !rowData.flatRatePerPolicy && (
            <div className={`flex flex-col text-xxs`}>
              <span
                className={`inline-flex items-center w-12 justify-center px-2.5 py-0.5 rounded-full 
              text-xs font-medium bg-blue-100 text-blue-800`}
              >
                {rowData.newPercentageConfie}
              </span>

              <div className="agmtColumn text-tertiary">Confie %</div>
            </div>
          )
        );
      },
    },
    {
      width: "20px",
      field: "newPercentageFranchise",
      hidden:
        !user.isFranchise ||
        (filteredValue.IsFiltered && filterParams.IsFranchise === false),
      render: (rowData) => {
        return (
          rowData.isFranchise &&
          !rowData.flatRatePerPolicy && (
            <div className={`flex flex-col text-xxs`}>
              <span
                className={`inline-flex items-center w-12 justify-center px-2.5 py-0.5 rounded-full 
              text-xs font-medium bg-blue-100 text-blue-800`}
              >
                {rowData.newPercentageFranchise}
              </span>

              <div className="agmtColumn text-tertiary">Franchise %</div>
            </div>
          )
        );
      },
    },
    {
      width: "20px",
      field: "renewalPercentage",
      render: (rowData) => {
        return (
          <>
            {rowData.flatRatePerPolicy ? (
              <div className="flex flex-col items-center font-bold text-xxs">
                <span
                  className={`inline-flex items-center w-12 justify-center px-2.5 py-0.5 rounded-full
               text-xs font-medium bg-pink-500 text-white`}
                >
                  ${rowData.renewalFlatRate ? rowData.renewalFlatRate : 0}
                </span>
                <div className={`agmtColumn text-blue-500`}>
                  Renewal Flat Rate
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center font-bold text-xxs">
                <span
                  className={`inline-flex items-center w-12 justify-center px-2.5 py-0.5 rounded-full
               text-xs font-medium bg-pink-500 text-white`}
                >
                  {rowData.renewalPercentage}
                </span>

                <div
                  className="
              agmtColumn text-blue-500"
                >
                  Renew %
                </div>
              </div>
            )}
          </>
        );
      },
    },
    {
      width: "20px",
      field: "renewPercentageConfie",
      hidden:
        !user.isFranchise ||
        (filteredValue.IsFiltered && filterParams.IsFranchise === false),
      render: (rowData) => {
        return (
          rowData.isFranchise &&
          !rowData.flatRatePerPolicy && (
            <div className={`flex flex-col text-xxs`}>
              <span
                className={`  inline-flex items-center w-12 justify-center px-2.5 py-0.5 rounded-full 
              text-xs font-medium bg-pink-100 text-pink-800`}
              >
                {rowData.renewPercentageConfie}
              </span>

              <div className="agmtColumn text-tertiary">Confie %</div>
            </div>
          )
        );
      },
    },
    {
      width: "20px",
      field: "renewPercentageFranchise",
      hidden:
        !user.isFranchise ||
        (filteredValue.IsFiltered && filterParams.IsFranchise === false),
      render: (rowData) => {
        return (
          rowData.isFranchise &&
          !rowData.flatRatePerPolicy && (
            <div className={`flex flex-col text-xxs`}>
              <span
                className={`inline-flex items-center w-12 justify-center px-2.5 py-0.5 rounded-full
               text-xs font-medium bg-pink-100 text-pink-800`}
              >
                {rowData.renewPercentageFranchise}
              </span>
              <div className="agmtColumn text-tertiary">Franchise %</div>
            </div>
          )
        );
      },
    },
    {
      field: "effectiveDate",
      type: "date",
      dateSetting: { locale: "en-US" },
      render: (rowData) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="blueAndBold uppercase">
              {rowData.effectiveDate
                ? new Date(rowData.effectiveDate).toLocaleDateString("en-US", {
                    timeZone: "UTC",
                  })
                : "unspecified"}
            </div>

            <div className={`mainLabeltextColor`}>Effective Date</div>
          </div>
        );
      },
    },
    {
      field: "expirationDate",
      type: "date",
      dateSetting: { locale: "en-US" },
      render: (rowData) => {
        return (
          <div className="flex flex-col text-sm">
            <div className="blueAndBold uppercase">
              {rowData.expirationDate
                ? new Date(rowData.expirationDate).toLocaleDateString("en-US", {
                    timeZone: "UTC",
                  })
                : "unspecified"}
            </div>

            <div className={`mainLabeltextColor`}>Expiration Date</div>
          </div>
        );
      },
    },

    {
      hidden:
        ((filteredValue.AgreementIsActive === undefined ||
          filteredValue.AgreementIsActive === null) &&
          isFiltered === true) ||
        isFiltered === false,
      field: "agreementIsActive",
      render: (rowData) => {
        let expDate = new Date(
          new Date(rowData.expirationDate).toLocaleDateString("en-US", {
            timeZone: "UTC",
          })
        );
        let dateToday = new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "UTC",
          })
        );
        return (
          <div className="flex  flex-col text-sm">
            {rowData.expirationDate &&
            rowData.agreementIsActive &&
            expDate >= dateToday
              ? "Active"
              : (rowData.expirationDate === null || rowData.expirationDate) &&
                !rowData.agreementIsActive &&
                (expDate >= dateToday || expDate <= dateToday)
              ? "Inactive"
              : rowData.expirationDate &&
                (rowData.agreementIsActive || !rowData.agreementIsActive) &&
                expDate < dateToday
              ? "Expired"
              : rowData.agreementIsActive
              ? "Active"
              : "Inactive"}

            <div className="mainLabeltextColor">Agreement Status</div>
          </div>
        );
      },
    },
    {
      field: "isFranchise",
      render: (rowData, rowStatus) => {
        if (rowStatus === "group") {
          return rowData;
        } else {
          return (
            <div className=" flex  flex-col text-sm">
              <div className="blueAndBold uppercase">
                {rowData.isFranchise ? "True" : "False"}
              </div>
              <div className="mainLabeltextColor">Franchise</div>
            </div>
          );
        }
      },
    },
  ];

  const handleBackToForm = () => {
    reset();
    setFilter(false);

    if (savedAgreementData?.isEdit) {
      const fixedRow = { ...savedAgreementData };

      if (Array.isArray(fixedRow.state)) {
        fixedRow.state = fixedRow.state
          .map((s) => (typeof s === "string" ? s : s.value))
          .join(",");
      }

      if (Array.isArray(fixedRow.policyType)) {
        fixedRow.policyType = fixedRow.policyType
          .map((p) => (typeof p === "string" ? p : p.value))
          .join(",");
      }

      setAgmtGroupData(savedAgreementData);
      setShowGroupView(true);
      setPendingEditRow(fixedRow);
      setFilterGrpParams({
        ...filterGrpParams,
        AgreementRepositoryId: [
          Number(savedAgreementData.agreementRepositoryId),
        ],
      });
    } else if (savedAgreementData?.isAdd) {
      setAddState(true);
    }
  };

  return (
    <>
      <div className="px-8 py-4">
        <div
          className={`${
            showGroupView || showFullView || addState ? "hidden" : "block"
          }`}
        >
          <div className="">
            <div className="flex items-center pb-2 justify-between">
              <div className="flex gap-2 items-center">
                <NewspaperIcon className="text-white bg-blue-500 rounded-md h-7 w-7  p-1" />
                <div className="text-gray-600 font-medium ml-2">
                  <h3 className="text-xs font-medium text-gray-500">
                    Agreements Module
                  </h3>
                  <h1 className="mr-auto font-bold text-primary text-md uppercase">
                    ALL AGREEMENTS
                  </h1>
                </div>
              </div>
              {(savedAgreementData?.isAdd || savedAgreementData?.isEdit) && (
                <button
                  type="button"
                  onClick={handleBackToForm}
                  className="text-quaternary border border-current opacity-100 hover:bg-hquaternary hover:scale-90 transition duration-500 shadow-md bg-transparent group relative flex items-center justify-center py-1 px-3 text-xs font-medium rounded-full hover:text-white hover:bg-quaternary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary"
                >
                  <span className="flex items-center justify-center gap-2">
                    <span className="inline-flex items-center justify-center rounded-full h-4 w-4 bg-quaternary group-hover:bg-white transition">
                      <ArrowRightIcon
                        className="h-3 w-3 text-white group-hover:text-quaternary"
                        aria-hidden="true"
                      />
                    </span>
                    Back to Form
                  </span>
                </button>
              )}
            </div>
            <div className="flex items-start py-2 justify-between">
              <div className="flex flex-row space-x-2">
                <div className="">
                  <button
                    disabled={getAgmtDetailsLoading}
                    className="disabled:opacity-25 disabled:cursor-not-allowed hover:scale-90 transition duration-500 
              flex justify-center items-center shadow-md px-3  h-7 text-xs gap-x-2 font-semibold text-primary border 
              hover:bg-primary selected hover:text-white border-primary rounded-md "
                    onClick={() => {
                      setFilter(!filter);
                    }}
                  >
                    <div>Filter By</div>
                    <FunnelIcon className="h-3 w-3" />
                  </button>
                </div>
              </div>
              <div className="flex justify-between gap-2">
                {userPermissions.includes(addPermission) && (
                  <AddButton
                    buttonText="Add"
                    disabled={
                      getAgmtDetailsLoading ||
                      savedAgreementData?.isAdd ||
                      savedAgreementData?.isEdit
                    }
                    onClick={() => setAddState(true)}
                  />
                )}
                {userPermissions.includes(addPermission) &&
                  user.isNonFranchise && (
                    <MassUploadButton
                      disabled={getAgmtDetailsLoading}
                      onClickFunction={() => {
                        setMassUploadModal(true);
                        setIsFranchiseUpload(false);
                      }}
                    >
                      <ArrowUpCircleIcon className="h-4 w-4 mr-2" />
                      <p className=""> Mass Upload Confie</p>
                    </MassUploadButton>
                  )}
                {userPermissions.includes(addPermission) &&
                  user.isFranchise && (
                    <MassUploadButton
                      disabled={getAgmtDetailsLoading}
                      onClickFunction={() => {
                        setMassUploadModal(true);
                        setIsFranchiseUpload(true);
                      }}
                    >
                      <ArrowUpCircleIcon className="h-4 w-4 mr-2" />
                      <p className="  ">Mass Upload Franchise</p>
                    </MassUploadButton>
                  )}
                <div className="box-content">
                  <DownloadButton
                    disabled={getAgmtDetailsLoading}
                    buttonValue={
                      getAgmtDetailsLoading ? "Downloading..." : "Download File"
                    }
                    onClick={() => downloadAgreements()}
                  />
                  <CSVLink
                    className="2xl:-mt-1 hidden"
                    ref={downloadRef}
                    {...csvReport}
                  ></CSVLink>
                </div>
              </div>
            </div>
          </div>
          <main className="flex justify-between gap-2">
            {filter && (
              <div className=" w-1/4 bg-white">
                <div className="">
                  <TableFilters
                    mutateSearchAgreements={mutateSearchAgreements}
                    setFilterConflictingAgreements={
                      setFilterConflictingAgreements
                    }
                    setConflictFilterParams={setConflictFilterParams}
                    reset={reset}
                  />
                </div>
              </div>
            )}

            <div
              className={
                !filter
                  ? "mb-4 w-full bg-white overflow-x-auto box-shadow"
                  : "w-full h-5/6 bg-white p-1 overflow-x-auto"
              }
            >
              {!massUploadModal && !addState && (
                <MaterialTableTS
                  columns={mainColumns}
                  data={
                    isFiltered
                      ? searchedAgreementsData?.map((data) => ({ ...data }))
                      : agreementsData?.map((data) => ({ ...data }))
                  }
                  isLoading={isFiltered ? searchAgmtLoading : agmtLoading}
                  tableRef={agmtTableRef}
                  headerStyle={{
                    display: "none",
                  }}
                />
              )}
            </div>
          </main>
        </div>
        {addState && (
          <AgreementForm
            getAgmtRefetch={(e) => {
              isFiltered && !filterConflictingAgreements
                ? mutateSearchAgreements(true)
                : filterConflictingAgreements
                ? mutateSearchAgreements(false)
                : agmtRefetch();
            }}
          />
        )}

        {showGroupView && agmtGroupData.agreementRepositoryId !== "" && (
          <AgmtGroupView
            mutateSearchAgreements={mutateSearchAgreements}
            agmtRefetch={agmtRefetch}
          />
        )}
        {showFullView && <AgmtFullViewModal />}
      </div>

      {massUploadModal && (
        <MassUpload
          isOpen={massUploadModal}
          setMassUploadModal={setMassUploadModal}
          isFranchiseUpload={isFranchiseUpload}
          agmtRefetch={(e) => {
            isFiltered ? mutateSearchAgreements(true) : agmtRefetch();
          }}
        />
      )}
    </>
  );
};

export default AgreementsTable;
